var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"inline-flex items-center justify-center h-[56px] w-[56px] p-5",attrs:{"type":"button"},on:{"click":_vm.openMenu}},[_c('BaseIcon',{staticClass:"w-5 h-5",attrs:{"name":"gw-menu"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }